import { render, staticRenderFns } from "./CreateFreeCostComponent.vue?vue&type=template&id=c04f6c18&scoped=true"
import script from "./CreateFreeCostComponent.vue?vue&type=script&lang=js"
export * from "./CreateFreeCostComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04f6c18",
  null
  
)

export default component.exports